import { of } from 'rxjs'
import { mergeMap } from 'rxjs/operators'
import { combineEpics, ofType } from 'redux-observable'

const exampleEpics = actions$ => actions$.pipe(
  ofType('test'),
  mergeMap(action => of({ type: 'success', action })),
)

export default combineEpics(
  exampleEpics,
)
